import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CompanionChatHistoryComponent } from '../companion-chat-history/companion-chat-history.component';
import { CompanionChatPanelComponent } from '../companion-chat-panel/companion-chat-panel.component';

@Component({
  standalone: true,
  selector: 'nimbus-companion-chat-page-page',
  templateUrl: './companion-chat-page.component.html',
  styleUrls: ['./companion-chat-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CompanionChatHistoryComponent, CompanionChatPanelComponent],
})
export class CompanionChatPageComponent {}
